import {TableDefinition} from '../../models';

export const LEAD_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.Lead.id',
    prop: 'id',
    visible: false,
    objectName: 'Lead',
    searchFieldType: 'NUMBER'
  },
  {
    key: 'API.fields.Lead.firstName',
    prop: 'firstName',
    visible: true,
    objectName: 'Lead',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Lead.lastName',
    prop: 'lastName',
    visible: true,
    objectName: 'Lead',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Lead.email',
    prop: 'email',
    visible: true,
    objectName: 'Lead',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Lead.phone',
    prop: 'phone',
    visible: true,
    objectName: 'Lead',
    searchFieldType: 'STRING',
  },
];
